export default __webpack_public_path__ + "static/media/caret-down.13d403cf.svg";